/**
 * Arama metninin ortak katlaması (ADR 0028 #37 madde 0): NFKD, birleşik işaretler atılır, `ı` →
 * `i`, sonra kök yerelde küçük harf. Form Tree süzgeci, önizleyicide belge içi arama ve sonraki
 * içerik araması (M8d) aynı işlevi kullanır; gemi ve ofis aynı sonucu verir. "İ" NFKD'de "I" ve
 * üst nokta olur; nokta atılınca "i" kalır.
 */
export function foldSearchText(text: string): string {
  return text.normalize('NFKD').replace(/\p{M}/gu, '').replaceAll('ı', 'i').toLowerCase();
}

/** Metin, katlanmış sorguyu alt dize olarak içeriyor mu; boş sorgu her şeyi eşler. */
export function matchesSearch(text: string, query: string): boolean {
  const needle = foldSearchText(query.trim());
  return needle === '' || foldSearchText(text).includes(needle);
}
